import React, { useEffect, useRef, useState } from 'react';
import Text from 'antd/lib/typography/Text';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { IApplicationState } from '../../store';

export interface IVoucherImageProps {
    showExpiary?: boolean;
    showImage?: boolean;
    imagePath?: string;
}

const VoucherImage: React.FunctionComponent<IVoucherImageProps> = (props) => {
    const { showExpiary = false, showImage = false, imagePath } = props;
    // TODO if we persue the customisable / personalised gift voucher feature, 
    // this will need to allow swapping the image used to match a config saved on the gift voucher record from the DB
    // Or to reference a passed image as a prop so we can have a selector on the UI for picking which image they want

    const defaultGiftVoucherImage = imagePath ?? `/static/Gift_Voucher_default_nolabel.webp`;

    const { t } = useTranslation();
    const expiryYears = useSelector((state: IApplicationState) => state.giftVoucher.configDetails?.expiryYears);
    const selectedLanguage = useSelector((state: IApplicationState) => state.intl.selectedLanguage);

    const voucherLabel = t('bookingSummary.labels.giftVoucher');

    let expirationDate = new Date();
    let expirationDateString = expirationDate.toDateString();

    if (expiryYears) {
        expirationDate.setFullYear(expirationDate.getFullYear() + expiryYears);
        expirationDateString = expirationDate.toDateString();
        let parts = expirationDateString.split(' ');
        expirationDateString = parts.slice(1).join(' ');
    }

    const ExpiryDate: React.FunctionComponent = () => {
        if (expiryYears) {
            return <Text>{exirationDateText}</Text>;
        } else {
            return <React.Fragment></React.Fragment>;
        }
    };

    const exirationDateText = t('giftVoucherSection.details.expirationLabel') + ': ' + expirationDateString;

    //Gift voucher images are expected to be 1063 * 650 pixels

    // For handling RTL langs (Aribic etc)
    const textAnchor = selectedLanguage.rtl ? "start" : "end";

    // To ensure the text fits in the 450 box for the image
    const textRef = useRef<SVGTextElement>(null);
    const [shouldClamp, setShouldClamp] = useState(false);
    const maxWidth = 450;

    useEffect(() => {
        if (textRef.current) {
            const bbox = textRef.current.getBBox();
            setShouldClamp(bbox.width > maxWidth);
        }
    }, [voucherLabel]);

    const lengthAdjust = shouldClamp ? "spacingAndGlyphs" : undefined;
    const textLength = shouldClamp ? maxWidth : undefined;


    // TODO - check if we want this in the regular booking flow or want to only show the image on the global gifts flow
    return (
        <div>
            {showImage &&
                <svg viewBox="0 0 1063 650" style={{ width: "100%", height: "auto", display: "block" }}>

                    {/*Base image*/}
                    <image href={defaultGiftVoucherImage} x="0" y="0" width="1063" height="650" />

                    {/*text elements layered over top of image, scale and move in sync with image automatically as svg parent container resizes*/}

                    {/*Ancor the label to the bottom right, and extend backwards as text length changes (eg translations)*/}
                    <text
                        x="950"
                        y="620"
                        direction={selectedLanguage.rtl ? "rtl" : "ltr" }
                        textAnchor={textAnchor}
                        fontFamily="inherit"
                        fill="white"
                        fontSize="60"
                        lengthAdjust={lengthAdjust}
                        textLength={textLength} /* stretch the rendered text up/down to fill the allowable space */
                        style={{ paintOrder: "stroke", stroke: "rgba(0,0.5,0,.5)", strokeWidth: 6 }}
                    >
                        {voucherLabel}
                    </text>
                </svg>
            }

            {showExpiary && <ExpiryDate />}
        </div>
    );
};

export default VoucherImage;
